<template>
    <RouterView />

    <link rel="stylesheet" :href="themePath" />
    
    <Modals />
    <Messages />
</template>

<script setup>
import { computed } from 'vue';

import Messages from '🔗/components/ui/Messages.vue';
import Modals from '@/components/modals/Modals.vue';

import { storeToRefs } from 'pinia';
// import stores from '@/stores';
import { baseUrl } from '🔗/utils/utils';

const others = stores.others();
const { themePath } = storeToRefs(others);

const user = stores.user();
const modals = stores.modals();
const nav = stores.nav();

// BG
const id = Math.floor(Math.random() * 3) + 1;
document.body.style['background-image'] = `url(${baseUrl}/themes/light/empty/${id}.jpg)`;
</script>

<style scoped lang="scss">
</style>
